import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckAppVersionService {

  constructor(private http: HttpClient) {}

  // Ruta relativa (sin "/" inicial): la app se despliega en Tomcat bajo un
  // context path, no en la raiz, y el build se genera con --base-href .
  // El query param y el header evitan que el navegador o un proxy devuelvan
  // una copia cacheada de build.txt.
  getBuild(): Observable<string> {
    return this.http.get(`assets/build.txt?_=${Date.now()}`, {
      responseType: 'text',
      headers: { 'Cache-Control': 'no-cache' }
    });
  }
}
